import React from 'react';
import { View, Text, StyleSheet, ActivityIndicator } from 'react-native';
import { useDashboardData } from './useDashboardData';

export interface TravelDashboardWidgetProps {
  location: string | null | undefined;
  baseCurrency?: string;
  compact?: boolean;
}

const TravelDashboardWidget: React.FC<TravelDashboardWidgetProps> = ({
  location,
  baseCurrency = 'CNY',
  compact = false,
}) => {
  console.log('🌍 [TravelDashboardWidget] === COMPONENT MOUNTED ===');
  console.log('[TravelDashboardWidget] Component rendering with props:', {
    location,
    baseCurrency,
    compact,
  });
  
  const { weather, exchangeRate, localTime } = useDashboardData(location, baseCurrency);
  
  console.log('[TravelDashboardWidget] Hook data:', {
    weather,
    exchangeRate,
    localTime,
  });
  
  if (!location) {
    console.log('[TravelDashboardWidget] No location, returning null');
    return null;
  }
  
  console.log('[TravelDashboardWidget] Rendering widget UI');
  
  return (
    <View style={[styles.container, compact && styles.containerCompact]}>
      {/* 當地天氣 */}
      <View style={styles.section}>
        <View style={styles.iconRow}>
          <Text style={styles.icon}>🌤️</Text>
          <Text style={styles.label}>當地天氣</Text>
        </View>
        {weather.loading ? (
          <ActivityIndicator size="small" color="#0B61D6" style={styles.loader} />
        ) : weather.error ? (
          <Text style={styles.errorText}>--</Text>
        ) : (
          <View style={styles.valueContainer}>
            <Text style={styles.mainValue}>{weather.icon} {weather.temperature}°C</Text>
            <Text style={styles.subValue}>{weather.condition}</Text>
          </View>
        )}
      </View>
      
      {/* 分隔线 */}
      <View style={styles.divider} />
      
      {/* 汇率 */}
      <View style={styles.section}>
        <View style={styles.iconRow}>
          <Text style={styles.icon}>💱</Text>
          <Text style={styles.label}>汇率</Text>
        </View>
        {exchangeRate.loading ? (
          <ActivityIndicator size="small" color="#0B61D6" style={styles.loader} />
        ) : exchangeRate.error ? (
          <Text style={styles.errorText}>--</Text>
        ) : exchangeRate.rate === 1 ? (
          <Text style={styles.subValue}>相同货币</Text>
        ) : (
          <View style={styles.valueContainer}>
            <Text style={styles.mainValue}>
              1 {exchangeRate.fromCurrency} =
            </Text>
            <Text style={styles.subValue}>
              {exchangeRate.rate.toFixed(2)} {exchangeRate.toCurrency}
            </Text>
          </View>
        )}
      </View>
      
      {/* 分隔线 */}
      <View style={styles.divider} />
      
      {/* 当地时间 */}
      <View style={styles.section}>
        <View style={styles.iconRow}>
          <Text style={styles.icon}>🕐</Text>
          <Text style={styles.label}>当地时间</Text>
        </View>
        <View style={styles.valueContainer}>
          <Text style={styles.mainValue}>{localTime.time}</Text>
          <Text style={styles.subValue}>{localTime.date}</Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    backgroundColor: '#F8F9FA',
    borderRadius: 8,
    padding: 10,
    marginTop: 0,
    marginBottom: 0,
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  containerCompact: {
    padding: 8,
    marginTop: 0,
    marginBottom: 0,
  },
  section: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 50,
  },
  iconRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  icon: {
    fontSize: 16,
    marginRight: 3,
  },
  label: {
    fontSize: 11,
    fontWeight: '600',
    color: '#6B7280',
  },
  valueContainer: {
    alignItems: 'center',
  },
  mainValue: {
    fontSize: 15,
    fontWeight: '700',
    color: '#111827',
    textAlign: 'center',
  },
  subValue: {
    fontSize: 11,
    color: '#6B7280',
    marginTop: 1,
    textAlign: 'center',
  },
  loader: {
    marginTop: 4,
  },
  errorText: {
    fontSize: 11,
    color: '#9CA3AF',
    marginTop: 2,
  },
  divider: {
    width: 1,
    backgroundColor: '#E5E7EB',
    marginHorizontal: 8,
  },
});

export default TravelDashboardWidget;
